var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupabase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "263px",
    viewBox: "0 0 256 263",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "supabase") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "20.8617445%",
    y1: "20.6868812%",
    x2: "63.4256086%",
    y2: "44.0710077%",
    id: "supabase-linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#249361",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ECF8E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.99116498%",
    y1: "-13.1584008%",
    x2: "21.4025077%",
    y2: "34.708062%",
    id: "supabase-linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.601512,258.578826 C142.884085,267.038157 129.263882,262.403261 129.102024,251.601817 L126.735244,93.6176533 L232.963622,93.6176533 C252.204429,93.6176533 262.935398,115.840956 250.971119,130.909887 L149.601512,258.578826 Z",
    fill: "url(#supabase-linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.601512,258.578826 C142.884085,267.038157 129.263882,262.403261 129.102024,251.601817 L126.735244,93.6176533 L232.963622,93.6176533 C252.204429,93.6176533 262.935398,115.840956 250.971119,130.909887 L149.601512,258.578826 Z",
    fillOpacity: 0.2,
    fill: "url(#supabase-linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.399023,4.36908575 C113.11645,-4.09118439 126.736889,0.544432392 126.898746,11.3460249 L127.935901,169.329953 L23.0369844,169.329953 C3.79559007,169.329953 -6.93568494,147.106651 5.02918175,132.037719 L106.399023,4.36908575 Z",
    fill: "#3ECF8E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupabase);
export default __webpack_public_path__ + "static/media/supabase.a7c08aff547b12db0cce99366bda7d57.svg";
export { ForwardRef as ReactComponent };